export { PageContent as default } from "@/features/companyDetail/components/Teams/PageContent"
export { getServerSideTeamsProps as getServerSideProps } from "@/features/companyDetail/server/getServerSideTeamsProps"
